/*----------------------------------
- SOLUTION PERSONA PAGES REGISTRY (SSOT)
----------------------------------*/

// Cross-runtime identity registry for the public /solutions/:slug persona
// presentation pages. Page copy lives in /client/catalogs/landing/solutions;
// server surfaces (sitemap, AI markdown mirrors) and client routes both
// key off this file. Two pages since 2026-11-04: the studios page left the website (decision E8,
// Gaetan's answer A) and `/solutions/studios` 301s to `/solutions/founders` (`publicRedirects.ts`).

/*----------------------------------
- TYPES
----------------------------------*/

export type SolutionPageRegistryEntry = {
    slug: string;
    /** Menu label ("For investors"). */
    label: string;
    pageTitle: string;
    metaDescription: string;
};

/*----------------------------------
- CONSTANTS
----------------------------------*/

export const SOLUTION_PAGE_BASE_PATH = '/solutions';

export const solutionPagePath = (slug: string): string => `${SOLUTION_PAGE_BASE_PATH}/${slug}`;

export const solutionPageMirrorPath = (slug: string): string => `/ai/pages/solution-${slug}.md`;

/*----------------------------------
- CATALOG (SSOT)
----------------------------------*/

export const SOLUTION_PAGE_REGISTRY: readonly SolutionPageRegistryEntry[] = [
    {
        slug: 'investors',
        label: 'For investors',
        pageTitle: 'Unique Domains for Investors: A Steady Stream of Names',
        metaDescription:
            'Search one-word domains by your buying rules, save it as a Radar, and review fresh matches with pricing, renewal, demand and risk. Track keepers in Watchlists.',
    },
    {
        slug: 'founders',
        label: 'For founders',
        pageTitle: 'Unique Domains for Founders: From Search to a Buyable Shortlist',
        metaDescription:
            'Describe your product and get real one-word domains with prices and availability. Compare candidates on fit, ownership, and risk, then buy at the registrar.',
    },
] as const;

export const getSolutionPage = (slug: string): SolutionPageRegistryEntry | null =>
    SOLUTION_PAGE_REGISTRY.find((entry) => entry.slug === slug) || null;
